import type { IWatermarkElement } from '@/types/watermarks.types';
import styles from '../watermark.module.css';
import type { CSSProperties } from 'react';

const TextEl = (el: IWatermarkElement) => {
  const { font, font_size, color, value } = el.settings.text;

  return (
    <div
      style={
        {
          userSelect: 'none',
          opacity: 'var(--wm-opacity)',
          '--wm-opacity': el.settings.opacity ?? 1,
          fontFamily: font?.name ? `'${font.name}', Inter` : 'Inter',
          fontSize: font_size,
          color,
          textShadow: `
            1px 0 rgba(0,0,0,0.25), -1px 0 rgba(0,0,0,0.25),
            0 1px rgba(0,0,0,0.25), 0 -1px rgba(0,0,0,0.25),
            1px 1px rgba(0,0,0,0.25), -1px -1px rgba(0,0,0,0.25),
            1px -1px rgba(0,0,0,0.25), -1px 1px rgba(0,0,0,0.25)
          `, // this is the closest we can get to a solid border without using WebkitTextStroke
          // which will cause blocks and lines to cross into the internal face of the text
          fontStyle: font?.style ?? 'normal',
          fontWeight: font?.weight ?? 'normal',
          letterSpacing: font?.letterSpacing ?? 'normal',
          textTransform: font?.caps ? 'uppercase' : 'none',
          whiteSpace: 'nowrap',
        } as CSSProperties
      }
      className={el.settings.duration === 'pulse' ? styles.pulse : ''}
    >
      {value}
    </div>
  );
};

export default TextEl;
